const key = 'app/upload';

export const uploadConstants = {
  // Upload history
  GET_UPLOAD_HISTORY: `${key}/GET_UPLOAD_HISTORY`,
  GET_UPLOAD_HISTORY_ERROR: `${key}/GET_UPLOAD_HISTORY_ERROR`,
  GET_UPLOAD_HISTORY_SUCCESS: `${key}/GET_UPLOAD_HISTORY_SUCCESS`,

  // Presigned URL generation
  GENERATE_URL: `${key}/GENERATE_URL`,
  GENERATE_URL_ERROR: `${key}/GENERATE_URL_ERROR`,
  GENERATE_URL_SUCCESS: `${key}/GENERATE_URL_SUCCESS`,

  // S3 finalize multipart upload
  UPLOAD_TO_S3: `${key}/UPLOAD_TO_S3`,
  UPLOAD_TO_S3_ERROR: `${key}/UPLOAD_TO_S3_ERROR`,
  UPLOAD_TO_S3_SUCCESS: `${key}/UPLOAD_TO_S3_SUCCESS`,

  // Delete history
  DELETE_HISTORY: `${key}/DELETE_HISTORY`,
  DELETE_HISTORY_ERROR: `${key}/DELETE_HISTORY_ERROR`,
  DELETE_HISTORY_SUCCESS: `${key}/DELETE_HISTORY_SUCCESS`,

  // Stripe payment intent / link
  GET_STRIPE_PAYMENT_LINK: `${key}/GET_STRIPE_PAYMENT_LINK`,
  GET_STRIPE_PAYMENT_LINK_ERROR: `${key}/GET_STRIPE_PAYMENT_LINK_ERROR`,
  GET_STRIPE_PAYMENT_LINK_SUCCESS: `${key}/GET_STRIPE_PAYMENT_LINK_SUCCESS`,

  // Stripe payment status
  GET_STRIPE_PAYMENT_STATUS: `${key}/GET_STRIPE_PAYMENT_STATUS`,
  GET_STRIPE_PAYMENT_STATUS_ERROR: `${key}/GET_STRIPE_PAYMENT_STATUS_ERROR`,
  GET_STRIPE_PAYMENT_STATUS_SUCCESS: `${key}/GET_STRIPE_PAYMENT_STATUS_SUCCESS`,

  // Stripe payment status
  GET_WALLET_BALANCE: `${key}/GET_WALLET_BALANCE`,
  GET_WALLET_BALANCE_ERROR: `${key}/GET_WALLET_BALANCE_ERROR`,
  GET_WALLET_BALANCE_SUCCESS: `${key}/GET_WALLET_BALANCE_SUCCESS`,

  // Local client-side payment/upload flow state
  SET_PAYMENT_PENDING_FILE: `${key}/SET_PAYMENT_PENDING_FILE`,
  CLEAR_PAYMENT_PENDING_FILE: `${key}/CLEAR_PAYMENT_PENDING_FILE`,
  SET_PAYMENT_PROCESS_ACTIVE: `${key}/SET_PAYMENT_PROCESS_ACTIVE`,
  SET_CANCEL_UPLOAD_AVAILABLE: `${key}/SET_CANCEL_UPLOAD_AVAILABLE`,
  SET_PAYMENT_DIALOG_ERROR: `${key}/SET_PAYMENT_DIALOG_ERROR`,

  SET_STRIPE_SESSION_ID: `${key}/SET_STRIPE_SESSION_ID`,
  SET_WALLET_PAYMENT_APPROVAL_NEEDED: `${key}/SET_WALLET_PAYMENT_APPROVAL_NEEDED`,
  APPROVE_WALLET_UPLOAD: `${key}/APPROVE_WALLET_UPLOAD`,

  RESET_UPLOAD: `${key}/RESET_UPLOAD`,

};
